<template>
  <!-- 用户信息详情 -->
  <div>
    <el-tabs v-model="activeName">
      <!-- 基本信息 -->
      <el-tab-pane :label="$t('pages.user.text8')" name="first">
        <Info :currentUser="currentUser" />
      </el-tab-pane>
      <!-- 车辆信息 -->
      <el-tab-pane :label="$t('pages.user.text9')" name="second">
        <Equipment :currentUser="currentUser" :activeName="activeName" />
      </el-tab-pane>
      <!-- 骑行信息 -->
      <el-tab-pane :label="$t('pages.user.text10')" name="third">
        <Ride :currentUser="currentUser" :activeName="activeName" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import Info from "./moudle/info.vue";
import Equipment from "./moudle/equipment.vue";
import Ride from "./moudle/ride.vue";
export default {
  data() {
    return {
      activeName: null,
      currentUser: {},
    };
  },
  components: {
    Info,
    Equipment,
    Ride,
  },
  mounted() {
    this.currentUser = JSON.parse(this.$route.query.currentUser);
    this.activeName = "first";
  },
};
</script>